import axios from 'axios';
import {
    createPanelAuthApi,
    type PanelCurrentUser
} from '@/shared/panel-auth';

export type CurrentUser = PanelCurrentUser;

const authHttp = axios.create({
    baseURL: '',
    withCredentials: true,
    headers: { Accept: 'application/json' },
    timeout: 30_000
});

const panelAuth = createPanelAuthApi({
    async get<T>(path: string) {
        const { data } = await authHttp.get<T>(path);
        return { data };
    },
    async post<T>(path: string) {
        const response = await authHttp.post<T>(path);
        return { data: response.data, status: response.status };
    }
});

export const getCurrentUser = panelAuth.getCurrentUser;
export const buildLoginUrl = panelAuth.buildLoginUrl;
export const logout = panelAuth.logout;